import React from "react";

import { Link } from 'react-router-dom';
import Layout from '../../components/token/Layout';
import ClaimToken from "../../components/token/ClaimTokens";


const ClaimTokensPage = () => {
  return (
    <>
       <Layout>
       <ClaimToken />
    </Layout>
    </>
  );
};

export default ClaimTokensPage;
